import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'red-cross-button',
    templateUrl: './red-cross-button.component.html',
    styleUrls: ['./red-cross-button.component.css'],
    standalone: false
})
export class RedCrossButtonComponent implements OnInit {
    @Input()
        public text?: string;

    @Output()
    press = new EventEmitter();
    constructor() {}

    onPress() {
        this.press.emit();
    }

    ngOnInit() {}
}
